function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgELearningDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.7 46.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.91,4.41A17.34,17.34,0,0,0,5.54,30a12.09,12.09,0,0,1,4.11,8.8v.31a7.11,7.11,0,0,0,7.11,7.11H18a7.13,7.13,0,0,0,7.12-7.11V38.09a10.22,10.22,0,0,1,3.72-7.71A17.33,17.33,0,0,0,30.41,5.92a17.81,17.81,0,0,0-1.5-1.51Zm-11,38H16.76a3.27,3.27,0,0,1-3.26-3.26s0-.5,0-.6h7.72v.6A3.27,3.27,0,0,1,18,42.41Zm8.29-14.92a14.73,14.73,0,0,0-4.55,7.21H19.28V20.85a5.78,5.78,0,0,0,3.86-5.43,1.93,1.93,0,0,0-3.86,0,1.93,1.93,0,1,1-3.85,0,1.93,1.93,0,0,0-3.86,0,5.79,5.79,0,0,0,3.86,5.43V34.7H12.88a16.59,16.59,0,0,0-4.72-7.48A13.49,13.49,0,0,1,15.78,4a14.12,14.12,0,0,1,1.59-.09,13.33,13.33,0,0,1,9,3.43,13.48,13.48,0,0,1,1.09,19,16.28,16.28,0,0,1-1.18,1.17Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearningDefault);
export default __webpack_public_path__ + "static/media/e-learning-default.5412594c.svg";
export { ForwardRef as ReactComponent };